import type { FaireProductEntity } from "../../entity_types/product";

export const p_hwyrs2nh9m: FaireProductEntity = {
  token: "p_hwyrs2nh9m",
  type: "product",
  name: "Lavender Hot Chocolate",
  brandToken: "b_1ihsd84dfh",
  brandName: "United Society of Shakers",
  imageUrl: "https://cdn.faire.com/fastly/fed3d096b8d4413497efc4538c2651d20be0e0ae846ab26ceeb9a0c2bf2279d0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/71a38a49113a05a5023d7bee26f7c59baf3820d0468cd31bcfcb1da16286f8f1.jpeg",
    "https://cdn.faire.com/fastly/cb570ee8df351e468e8abefb2bec76cd929e8765637dcbed7216a96bc6e90612.jpeg",
    "https://cdn.faire.com/fastly/b17e2520bb29daf9501d698b5d4556f9b1bdec0e8408b99e2be345e47fdaad51.jpeg",
    "https://cdn.faire.com/fastly/bff2adf0ab6faa1768e3eeb989e0f3429600f672a05ee753fe21d3dcbeb67928.jpeg",
    "https://cdn.faire.com/fastly/e35be984ea98274e9953b7337e15bc6076cabd7be1696e776a6b30fef4464234.jpeg",
    "https://cdn.faire.com/fastly/9e3a2efee06786a60d14f580a593aee5e9487d49721a4ec9683e816292ed6f70.jpeg"
  ],
  priceDollars: 12,
  description: "A slow, soothing cocoa blend, Lavender Hot Chocolate combines velvety cocoa, rich brown sugar, and finely milled lavender blossoms. It opens with deep chocolate richness, then softens into a calming floral lift, creating a gently aromatic cup designed for quiet evenings and unhurried moments of indulgence. Approximately 16 servings per container. 3.4\" x 4.2\" tin with twist closure & interior plastic bag.",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:06:55.830Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
